"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[67651],{

/***/ 31152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ pricing_plans; }
/* harmony export */ });
/* harmony import */ var constant_functions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60538);

var pricing_plans = [
    {
        _id: 1,
        id: "community_monthly",
        fresh_work_title: "Community",
        title: "Community",
        price: {
            dollar_sign: "$",
            title: "month",
            true: "0",
            false: "0"
        },
        yearly_charge: "Charged now - $0/yr",
        description: "Start without any base fee. For every community member to get their concept into a product.",
        includes: [
            "No transaction fee",
            "Community Support",
            "Free Tradly Hosted Website"
        ],
        features: [
            {
                title: "No transaction fee",
                info: "",
                link: ""
            },
            {
                title: "Community support",
                info: "",
                link: ""
            },
            {
                title: "Free Tradly hosted website",
                info: "",
                link: ""
            },
            {
                title: "Add your custom domain",
                info: "",
                link: ""
            },
            {
                title: "Editor - 3 Day page history",
                info: "",
                link: ""
            }, 
        ],
        history_timeline: 3,
        link: (0,constant_functions__WEBPACK_IMPORTED_MODULE_0__.getAuthKey)() === undefined ? "/signup" : "/workspace/plans",
        btn_title: "Start Building For Free"
    },
    {
        _id: 2,
        id: "2025-starter",
        fresh_work_title: "Starter",
        title: "Starter",
        price: {
            dollar_sign: "$",
            title: "month",
            true: "17",
            false: "31"
        },
        yearly_charge: "Charged now - $204/yr",
        description: "For Individual & Startups validating their idea. Comes with all essential to validate with your target audience.",
        includes: [
            "No transaction fee",
            "Community + Livechat + Emails",
            "No Tradly Branding in website", 
        ],
        features: [
            {
                title: "No transaction fee",
                info: "",
                link: ""
            },
            {
                title: "+Limited Support",
                info: "3 Days response time for non-critical",
                link: "/pricing/marketplace#support"
            },
            {
                title: "No Tradly Branding in website",
                info: "",
                link: ""
            },
            {
                title: "Unlimited Custom Attributes",
                info: "",
                link: ""
            },
            {
                title: "30 Day page history",
                info: "",
                link: ""
            }, 
        ],
        history_timeline: 30,
        link: (0,constant_functions__WEBPACK_IMPORTED_MODULE_0__.getAuthKey)() === undefined ? "/signup" : "/workspace/plans",
        btn_title: " Start 7 Days Trial"
    },
    {
        _id: 3,
        id: "2025-growth",
        fresh_work_title: "Growth",
        title: "Growth",
        price: {
            dollar_sign: "$",
            title: "month",
            true: "54",
            false: "99"
        },
        yearly_charge: "Charged now - $648/yr",
        description: " For proven business on their growth Stage. Have custom needs and additional integrations to grow.",
        includes: [
            "No transaction fee",
            "Slack Private Channel",
            'Custom "From Emails"',
            "Additional Mini Tools & Integrations", 
        ],
        features: [
            {
                title: "No transaction fee",
                info: "",
                link: ""
            },
            {
                title: "+ Support Portal",
                info: "48 Hours response time for non-critical",
                link: "/pricing/marketplace#support"
            },
            {
                title: "Custom 'From Email'",
                info: "",
                link: ""
            },
            {
                title: "Additional Mini Tools & Integrations",
                info: "",
                link: ""
            },
            {
                title: "Personalised Onboarding calls*",
                info: "",
                link: ""
            },
            {
                title: "90 Day page history",
                info: "",
                link: ""
            },
            {
                title: "Multi Currencies & Multi Languages",
                info: "",
                link: ""
            },
            {
                title: "Gated Subscription",
                info: "Subscription charges for people to open accounts & submit listings",
                link: ""
            },
            {
                title: "Social logins",
                info: "Signup/in via Google, Meta",
                link: ""
            },
            {
                title: "Webooks",
                info: "To connect with Zapier & Make",
                link: ""
            },
            {
                title: "Role-based access control (RBAC)",
                info: "",
                link: ""
            }, 
        ],
        history_timeline: 90,
        link: (0,constant_functions__WEBPACK_IMPORTED_MODULE_0__.getAuthKey)() === undefined ? "/signup" : "/workspace/plans",
        btn_title: " Start 7 Days Trial",
        is_show_star: true
    },
    {
        _id: 4,
        id: "2025-scale",
        fresh_work_title: "Scale (previously business)",
        title: "Scale",
        price: {
            dollar_sign: "$",
            title: "month",
            true: "164",
            false: "299"
        },
        yearly_charge: "Charged now - $1968/yr",
        description: "Business who are in growth stage and looking to have be-spoke solution and other custom requirements.",
        includes: [
            "No transaction fee",
            "Priority Support",
            "Multiple Channels(App Support)",
            "RBAC"
        ],
        history_timeline: "unlimited",
        link: (0,constant_functions__WEBPACK_IMPORTED_MODULE_0__.getAuthKey)() === undefined ? "/signup" : "/workspace/plans",
        features: [
            {
                title: "No transaction fee",
                info: "",
                link: ""
            },
            {
                title: "Priority Support",
                info: "24 hour response time for non-critical",
                link: "/pricing/marketplace#support"
            },
            {
                title: "Multiple Channels (App Support)",
                info: "",
                link: ""
            },
            {
                title: "Single Sign-on (SSO)",
                info: "",
                link: ""
            },
            {
                title: "Unlimited page history",
                info: "",
                link: ""
            }, 
        ],
        btn_title: " Start 7 Days Trial"
    }, 
];


/***/ }),

/***/ 73323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);



var SpecialPlans = function() {
    var plans_list = [
        {
            title: "Super Starter for $4.9",
            description: 'Add on to the community package to remove "Built With Tradly" Button. Other features same as community',
            button_title: "Buy the Add-On",
            image: "https://media.tradly.app/images/bdshop1/19690/Screenshot2023-12-23at7-cyr7h0NU.png",
            url: "/workspace/plans"
        },
        {
            title: "Custom Plans",
            description: "Get custom plans if you have clear annual expectation and other business requirements.",
            button_title: "Contact for a Quote",
            image: "https://media.tradly.app/images/bdshop1/19690/Screenshot2023-12-23at7-cyr7h0NU.png",
            url: "/support"
        },
        {
            title: "Custom Template Development",
            description: "If you are looking for a custom development with concierge service. Starts from $350",
            button_title: "Contact for a Quote",
            image: "https://media.tradly.app/images/bdshop1/19690/Screenshot2023-12-23at7-cyr7h0NU.png",
            url: "/support"
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: " flex justify-center gap-10 flex-wrap",
        children: plans_list === null || plans_list === void 0 ? void 0 : plans_list.map(function(plan) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "bg-[#E8FFFA] shadow max-w-xs min-h-[200px] py-10 px-5 flex-grow flex flex-col gap-8",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: " flex flex-col items-center justify-center gap-3 flex-grow",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: plan === null || plan === void 0 ? void 0 : plan.image,
                                alt: "",
                                className: " h-20 object-contain"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: " text-2xl font-semibold text-center",
                                children: plan === null || plan === void 0 ? void 0 : plan.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: " text-sm text-gray-600 text-center ",
                                children: plan === null || plan === void 0 ? void 0 : plan.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: plan === null || plan === void 0 ? void 0 : plan.url,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: " w-full btn_primary mx-auto",
                            children: plan === null || plan === void 0 ? void 0 : plan.button_title
                        })
                    })
                ]
            });
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SpecialPlans);


/***/ }),

/***/ 67651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ marketplace_PricingTablesMarketplace; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/store/User_store.js
var User_store = __webpack_require__(59155);
var User_store_default = /*#__PURE__*/__webpack_require__.n(User_store);
// EXTERNAL MODULE: ./constant/AllIcons.js
var AllIcons = __webpack_require__(47520);
// EXTERNAL MODULE: ./constant/functions.js
var functions = __webpack_require__(60538);
// EXTERNAL MODULE: ./constant/mixpnael.js
var mixpnael = __webpack_require__(70441);
// EXTERNAL MODULE: ./constant/url.js
var url = __webpack_require__(99741);
// EXTERNAL MODULE: ./data/PringPlanData.js
var PringPlanData = __webpack_require__(31152);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/components/PricingPlan/SpecialPlans.jsx
var SpecialPlans = __webpack_require__(73323);
// EXTERNAL MODULE: ./src/components/Tradly/Faqs.js
var Faqs = __webpack_require__(62983);
// EXTERNAL MODULE: ./src/components/Tradly/FeaturesTable.js + 2 modules
var FeaturesTable = __webpack_require__(79223);
// EXTERNAL MODULE: ./src/redux/features/plans/plansApi.js
var plansApi = __webpack_require__(55737);
// EXTERNAL MODULE: ./src/utils/getFormattedPrice.js
var getFormattedPrice = __webpack_require__(33692);
;// CONCATENATED MODULE: ./src/components/Tradly/Pricing/SMEPricing.jsx













var SMEPricing = function(param) {
    var is_annual = param.is_annual, userDetails = param.userDetails, tenantDetails = param.tenantDetails;
    var ref = (0,plansApi/* useGetPlansQuery */.j)(), plan_resp = ref.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: " grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[11px]",
        children: PringPlanData/* pricing_plans */.B === null || PringPlanData/* pricing_plans */.B === void 0 ? void 0 : PringPlanData/* pricing_plans.map */.B.map(function(item, index) {
            var ref, ref1, ref2;
            var plan = plan_resp === null || plan_resp === void 0 ? void 0 : (ref = plan_resp.plans) === null || ref === void 0 ? void 0 : ref.find(function(p) {
                return p.name.includes(item.id) && (is_annual ? p.recurring_type === "yearly" : p.recurring_type === "monthly");
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (item === null || item === void 0 ? void 0 : item.is_show_star) ? "relative flex flex-col h-full py-5 px-6 rounded    shadow-xl border-2 border-blue-500" : "relative flex flex-col h-full py-5 px-6 rounded bg-white shadow-xl ",
                "data-aos": "zoom-y-out",
                "data-aos-delay": "450",
                children: [
                    (item === null || item === void 0 ? void 0 : item.is_show_star) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 right-0 mr-5 p-3 -mt-5 bg-yellow-500 rounded-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            className: "w-4 h-4 fill-current text-white",
                            viewBox: "0 0 16 16",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M15.145 5.05l-4.316-.627L8.898.513c-.338-.684-1.456-.684-1.794 0l-1.93 3.91-4.317.627a1.002 1.002 0 00-.554 1.707l3.124 3.044-.737 4.3a1 1 0 001.45 1.053L8 13.125l3.862 2.03c.728.381 1.59-.234 1.45-1.054l-.736-4.299L15.7 6.758a1.003 1.003 0 00-.555-1.708z"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-2xl font-bold mb-1",
                                children: item === null || item === void 0 ? void 0 : item.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inline-flex items-baseline mb-1",
                                children: [
                                    plan ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[2em] font-bold",
                                        children: (0,getFormattedPrice/* getFormattedPrice */._)({
                                            currency_code: plan.currency,
                                            amount: plan.amount
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "text-[2em] font-bold",
                                        children: [
                                            item === null || item === void 0 ? void 0 : (ref1 = item.price) === null || ref1 === void 0 ? void 0 : ref1.dollar_sign,
                                            is_annual ? item.price.true : item.price.false
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "text-gray-900 pl-2",
                                        children: [
                                            "/",
                                            item.price.title
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: " text-lightGray text-sm font-medium",
                                children: "per month"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: " text-lightGray text-sm font-medium",
                                children: is_annual ? "billed yearly" : "billed monthly"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-lg text-gray-900 mt-4",
                                children: item === null || item === void 0 ? void 0 : item.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "text-gray-900 -mb-2 flex-grow",
                        children: item === null || item === void 0 ? void 0 : (ref2 = item.features) === null || ref2 === void 0 ? void 0 : ref2.map(function(feature) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "flex items-center justify-between mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                className: "w-3 h-3 fill-current text-green-500 mr-3 flex-shrink-0",
                                                viewBox: "0 0 12 12",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"
                                                })
                                            }),
                                            (feature === null || feature === void 0 ? void 0 : feature.link) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: feature === null || feature === void 0 ? void 0 : feature.link,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "underline",
                                                    children: feature === null || feature === void 0 ? void 0 : feature.title
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: feature === null || feature === void 0 ? void 0 : feature.title
                                            })
                                        ]
                                    }),
                                    (feature === null || feature === void 0 ? void 0 : feature.info) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "ml-1 group",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: " cursor-pointer",
                                                children: AllIcons.info_icon
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: " hidden absolute group-hover:block bg-gray-600 text-gray-50 text-sm mt-2 text-start p-2 z-20 rounded-md max-w-xs w-full right-0",
                                                children: feature === null || feature === void 0 ? void 0 : feature.info
                                            })
                                        ]
                                    })
                                ]
                            });
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "border-t border-gray-200 pt-5 mt-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "btn-sm !py-[9px] text-white bg-blue-900 hover:bg-blue-700 w-full",
                            href: item.link,
                            onClick: function() {
                                var _obj;
                                (0,mixpnael/* MixpanelTracking */.n5)(mixpnael/* MixpanelEventName.pricing_page */.aK.pricing_page, (_obj = {}, (0,_define_property/* default */.Z)(_obj, mixpnael/* MixpanelPropertiesName.user_name */.Oe.user_name, userDetails === null || userDetails === void 0 ? void 0 : userDetails.name), (0,_define_property/* default */.Z)(_obj, mixpnael/* MixpanelPropertiesName.user_email */.Oe.user_email, userDetails === null || userDetails === void 0 ? void 0 : userDetails.email), (0,_define_property/* default */.Z)(_obj, mixpnael/* MixpanelPropertiesName.tenant_name */.Oe.tenant_name, tenantDetails === null || tenantDetails === void 0 ? void 0 : tenantDetails.id), (0,_define_property/* default */.Z)(_obj, mixpnael/* MixpanelPropertiesName.pricing_page_action */.Oe.pricing_page_action, mixpnael/* MixpanelPropertiesValues.buy_now */.JA.buy_now), _obj));
                                (0,functions.getAuthKey)() === undefined && localStorage.setItem("selected_plan", item.id);
                            },
                            children: index == 0 ? "Start Building For Free" : "Start 7 Days Trial"
                        })
                    })
                ]
            });
        })
    });
};
/* harmony default export */ var Pricing_SMEPricing = (SMEPricing);

;// CONCATENATED MODULE: ./src/components/Tradly/Pricing/AnnualToggle.jsx


var AnnualToggle = function(param) {
    var is_yearly = param.is_yearly, setIsYearly = param.setIsYearly;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex w-full md:w-[300px] p-1 bg-gray-200 rounded",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "absolute inset-0 m-1 pointer-events-none",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "absolute inset-0 w-1/2 bg-white rounded shadow transform transition duration-150 ease-in-out ".concat(is_yearly ? "translate-x-0" : "translate-x-full")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "relative flex-1 text-sm font-medium p-1 transition duration-150 ease-in-out ".concat(!is_yearly && "text-gray-500"),
                onClick: function(e) {
                    e.preventDefault();
                    setIsYearly(true);
                },
                children: [
                    "Bill Yearly ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-green-500",
                        children: "-45%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "relative flex-1 text-sm font-medium p-1 transition duration-150 ease-in-out ".concat(is_yearly && "text-gray-500"),
                onClick: function(e) {
                    e.preventDefault();
                    setIsYearly(false);
                },
                children: "Bill Monthly"
            })
        ]
    });
};
/* harmony default export */ var Pricing_AnnualToggle = (AnnualToggle);

;// CONCATENATED MODULE: ./src/components/Tradly/Pricing/PricingModelToggle.jsx



var PricingModelToggle = function(param) {
    var is_business_model = param.is_business_model, setISBusinessModel = param.setISBusinessModel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative w-full max-w-full md:max-w-fit grid grid-cols-2 p-1 bg-gray-200 rounded",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "absolute inset-0 m-1 pointer-events-none",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "absolute inset-0 w-1/2 bg-white rounded shadow transform transition duration-150 ease-in-out ".concat(!is_business_model ? "translate-x-0" : "translate-x-full")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "relative   flex   p-1 px-3 transition duration-150 ease-in-out ".concat(is_business_model && "text-gray-500"),
                onClick: function(e) {
                    e.preventDefault();
                    setISBusinessModel(false);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: " flex-1 flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "h3 text-start",
                                children: "SMB"
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: " text-start text-sm",
                                children: " Self Serve"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ml-1 group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: " cursor-pointer",
                                children: AllIcons.info_icon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: " hidden absolute group-hover:block bg-gray-600 text-gray-50 text-sm mt-12 text-start p-2 z-20 rounded-md max-w-xs w-full right-0",
                                children: "Our Self Serve plans are made affordable to meet the growing demands of everyone."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "relative   flex  text-sm font-medium py-1 px-3 transition duration-150 ease-in-out ".concat(!is_business_model && "text-gray-500"),
                onClick: function(e) {
                    e.preventDefault();
                    setISBusinessModel(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: " flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "h3",
                                children: "Enterprise"
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: " text-start text-sm",
                                children: " Customised Service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ml-1 group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: " cursor-pointer",
                                children: AllIcons.info_icon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: " hidden absolute group-hover:block bg-gray-600 text-gray-50 text-sm mt-12 text-start p-2 z-20 rounded-md max-w-xs w-full right-0",
                                children: "Customised service to meet the needs of enterprises. Everything managed with additional services."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Pricing_PricingModelToggle = (PricingModelToggle);

;// CONCATENATED MODULE: ./src/components/Tradly/Pricing/EnterPrise/BottomCard.jsx


var BottomCard = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: " w-full bg-[#f8fafc] p-4 md:p-8 min-h-[500px",
        children: /*#__PURE__*/ _jsxs("div", {
            className: " relative flex flex-col items-center my-20 bg-white px-6 py-10 md:p-[64px] rounded-[1rem] gap-4 text-center",
            children: [
                /*#__PURE__*/ _jsx("img", {
                    src: "https://media.tradly.app/images/marketplace/95817/635b46228f935154d59621e8_emoji02-7TD1i4sb.webp",
                    alt: "Default",
                    className: "absolute -top-[15%] left-5 md:left-10 h-[100px] w-[100px] md:h-[144px] md:w-[144px]"
                }),
                /*#__PURE__*/ _jsx("h2", {
                    className: "h2 max-w-[464px] mx-auto ",
                    children: "The all-in-one platform to drive community-led growth"
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: " text-start text-lightGray text-[18px] font-medium leading-[27px]",
                    children: "Streamline your customer experience and create powerful customer communities in minutes"
                }),
                /*#__PURE__*/ _jsx("button", {
                    className: "btn btn_primary !rounded-full",
                    children: "Book a Demo"
                }),
                /*#__PURE__*/ _jsx("img", {
                    src: "https://media.tradly.app/images/marketplace/11172/635b46b66718fe1f25341f29_memoji-ZZJsGJLc.webp",
                    alt: "Default",
                    className: "absolute bottom-5 md:bottom-10 right-4 md:right-10 h-[80px] w-[80px]"
                })
            ]
        })
    });
};
/* harmony default export */ var EnterPrise_BottomCard = ((/* unused pure expression or super */ null && (BottomCard)));

;// CONCATENATED MODULE: ./data/Pricing/EntrpriseFeatures.js

var EntrpriseFeatures_support_features = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 10V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H10.5M13 11H8M11 15H8M16 7H8M19.25 17V15.25C19.25 14.2835 18.4665 13.5 17.5 13.5C16.5335 13.5 15.75 14.2835 15.75 15.25V17M15.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V18.6C21 18.0399 21 17.7599 20.891 17.546C20.7951 17.3578 20.6422 17.2049 20.454 17.109C20.2401 17 19.9601 17 19.4 17H15.6C15.0399 17 14.7599 17 14.546 17.109C14.3578 17.2049 14.2049 17.3578 14.109 17.546C14 17.7599 14 18.0399 14 18.6V19.4C14 19.9601 14 20.2401 14.109 20.454C14.2049 20.6422 14.3578 20.7951 14.546 20.891C14.7599 21 15.0399 21 15.6 21Z",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        }),
        title: "Data encryption",
        description: "We use state-of the art encryption to ensure that your member data is always secure."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 2.4578C14.053 2.16035 13.0452 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 10.2847 21.5681 8.67022 20.8071 7.25945M17 5.75H17.005M10.5001 21.8883L10.5002 19.6849C10.5002 19.5656 10.5429 19.4502 10.6205 19.3596L13.1063 16.4594C13.3106 16.2211 13.2473 15.8556 12.9748 15.6999L10.1185 14.0677C10.0409 14.0234 9.97663 13.9591 9.93234 13.8814L8.07046 10.6186C7.97356 10.4488 7.78657 10.3511 7.59183 10.3684L2.06418 10.8607M21 6C21 8.20914 19 10 17 12C15 10 13 8.20914 13 6C13 3.79086 14.7909 2 17 2C19.2091 2 21 3.79086 21 6ZM17.25 5.75C17.25 5.88807 17.1381 6 17 6C16.8619 6 16.75 5.88807 16.75 5.75C16.75 5.61193 16.8619 5.5 17 5.5C17.1381 5.5 17.25 5.61193 17.25 5.75Z",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        }),
        title: "Data residency",
        description: "Select your preferred location for data storage — from Germany to the United States."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M21.2 22C21.48 22 21.62 22 21.727 21.9455C21.8211 21.8976 21.8976 21.8211 21.9455 21.727C22 21.62 22 21.48 22 21.2V10.8C22 10.52 22 10.38 21.9455 10.273C21.8976 10.1789 21.8211 10.1024 21.727 10.0545C21.62 10 21.48 10 21.2 10L18.8 10C18.52 10 18.38 10 18.273 10.0545C18.1789 10.1024 18.1024 10.1789 18.0545 10.273C18 10.38 18 10.52 18 10.8V13.2C18 13.48 18 13.62 17.9455 13.727C17.8976 13.8211 17.8211 13.8976 17.727 13.9455C17.62 14 17.48 14 17.2 14H14.8C14.52 14 14.38 14 14.273 14.0545C14.1789 14.1024 14.1024 14.1789 14.0545 14.273C14 14.38 14 14.52 14 14.8V17.2C14 17.48 14 17.62 13.9455 17.727C13.8976 17.8211 13.8211 17.8976 13.727 17.9455C13.62 18 13.48 18 13.2 18H10.8C10.52 18 10.38 18 10.273 18.0545C10.1789 18.1024 10.1024 18.1789 10.0545 18.273C10 18.38 10 18.52 10 18.8V21.2C10 21.48 10 21.62 10.0545 21.727C10.1024 21.8211 10.1789 21.8976 10.273 21.9455C10.38 22 10.52 22 10.8 22L21.2 22Z",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M10 6.8C10 6.51997 10 6.37996 10.0545 6.273C10.1024 6.17892 10.1789 6.10243 10.273 6.0545C10.38 6 10.52 6 10.8 6H13.2C13.48 6 13.62 6 13.727 6.0545C13.8211 6.10243 13.8976 6.17892 13.9455 6.273C14 6.37996 14 6.51997 14 6.8V9.2C14 9.48003 14 9.62004 13.9455 9.727C13.8976 9.82108 13.8211 9.89757 13.727 9.9455C13.62 10 13.48 10 13.2 10H10.8C10.52 10 10.38 10 10.273 9.9455C10.1789 9.89757 10.1024 9.82108 10.0545 9.727C10 9.62004 10 9.48003 10 9.2V6.8Z",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                })
            ]
        }),
        title: "Penetration test",
        description: "Security audits through a third-party specialist for cloud infrastructure best practices."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M11.302 21.6149C11.5234 21.744 11.6341 21.8086 11.7903 21.8421C11.9116 21.8681 12.0884 21.8681 12.2097 21.8421C12.3659 21.8086 12.4766 21.744 12.698 21.6149C14.646 20.4784 20 16.9084 20 12V7.2176C20 6.41809 20 6.01833 19.8692 5.6747C19.7537 5.37114 19.566 5.10028 19.3223 4.88553C19.0465 4.64244 18.6722 4.50208 17.9236 4.22135L12.5618 2.21067C12.3539 2.13271 12.25 2.09373 12.143 2.07828C12.0482 2.06457 11.9518 2.06457 11.857 2.07828C11.75 2.09373 11.6461 2.13271 11.4382 2.21067L6.0764 4.22135C5.3278 4.50208 4.9535 4.64244 4.67766 4.88553C4.43398 5.10028 4.24627 5.37114 4.13076 5.6747C4 6.01833 4 6.41809 4 7.2176V12C4 16.9084 9.35396 20.4784 11.302 21.6149Z",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M13 7.5L10 10.5L14 12.5L11 15.5",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                })
            ]
        }),
        title: "Custom SSL",
        description: "Use the certificate you already own and show your brand name on the SSL certificate."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M8.10008 21.221C6.71021 19.2375 5.89258 16.8243 5.89258 14.2187C5.89258 10.8443 8.6265 8.10938 11.9989 8.10938C15.3712 8.10938 18.1051 10.8443 18.1051 14.2187",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M8.10008 21.221C6.71021 19.2375 5.89258 16.8243 5.89258 14.2187C5.89258 10.8443 8.6265 8.10938 11.9989 8.10938C15.3712 8.10938 18.1051 10.8443 18.1051 14.2187",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M18.4359 20.3118C18.3259 20.3179 18.218 20.3281 18.107 20.3281C14.7347 20.3281 12.0007 17.5931 12.0007 14.2188",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M18.4361 20.3118C18.3262 20.3179 18.2182 20.3281 18.1073 20.3281C14.7349 20.3281 12.001 17.5931 12.001 14.2188",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M13.2694 21.9999C10.675 20.382 8.94705 17.5024 8.94705 14.2187C8.94705 12.5315 10.3145 11.164 12.0007 11.164C13.6869 11.164 15.0543 12.5315 15.0543 14.2187C15.0543 15.9059 16.4218 17.2733 18.108 17.2733C19.7942 17.2733 21.1616 15.9059 21.1616 14.2187C21.1616 9.1571 17.0602 5.05469 12.0017 5.05469C6.94319 5.05469 2.8418 9.1571 2.8418 14.2187C2.8418 15.3469 2.96806 16.4455 3.20021 17.5045",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M13.2694 21.9999C10.675 20.382 8.94705 17.5024 8.94705 14.2187C8.94705 12.5315 10.3145 11.164 12.0007 11.164C13.6869 11.164 15.0543 12.5315 15.0543 14.2187C15.0543 15.9059 16.4218 17.2733 18.108 17.2733C19.7942 17.2733 21.1616 15.9059 21.1616 14.2187C21.1616 9.1571 17.0602 5.05469 12.0017 5.05469C6.94319 5.05469 2.8418 9.1571 2.8418 14.2187C2.8418 15.3469 2.96806 16.4455 3.20021 17.5045",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M20.5257 5.86313C18.4435 3.4978 15.399 2 12.0002 2C8.60136 2 5.55687 3.4978 3.47461 5.86313",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M20.5257 5.86313C18.4435 3.4978 15.399 2 12.0002 2C8.60136 2 5.55687 3.4978 3.47461 5.86313",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                })
            ]
        }),
        title: "Custom Security header",
        description: "A powerful defense mechanism in the browser to combat vulnerabilities and keep community safe."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 4C16.93 4 17.395 4 17.7765 4.10222C18.8117 4.37962 19.6204 5.18827 19.8978 6.22354C20 6.60504 20 7.07003 20 8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V8C4 7.07003 4 6.60504 4.10222 6.22354C4.37962 5.18827 5.18827 4.37962 6.22354 4.10222C6.60504 4 7.07003 4 8 4M9 15L11 17L15.5 12.5M9.6 6H14.4C14.9601 6 15.2401 6 15.454 5.89101C15.6422 5.79513 15.7951 5.64215 15.891 5.45399C16 5.24008 16 4.96005 16 4.4V3.6C16 3.03995 16 2.75992 15.891 2.54601C15.7951 2.35785 15.6422 2.20487 15.454 2.10899C15.2401 2 14.9601 2 14.4 2H9.6C9.03995 2 8.75992 2 8.54601 2.10899C8.35785 2.20487 8.20487 2.35785 8.10899 2.54601C8 2.75992 8 3.03995 8 3.6V4.4C8 4.96005 8 5.24008 8.10899 5.45399C8.20487 5.64215 8.35785 5.79513 8.54601 5.89101C8.75992 6 9.03995 6 9.6 6Z",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        }),
        title: "Password strength",
        description: "Create a custom password complexity for the members and adhere your security standards."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 4C16.93 4 17.395 4 17.7765 4.10222C18.8117 4.37962 19.6204 5.18827 19.8978 6.22354C20 6.60504 20 7.07003 20 8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V8C4 7.07003 4 6.60504 4.10222 6.22354C4.37962 5.18827 5.18827 4.37962 6.22354 4.10222C6.60504 4 7.07003 4 8 4M9 15L11 17L15.5 12.5M9.6 6H14.4C14.9601 6 15.2401 6 15.454 5.89101C15.6422 5.79513 15.7951 5.64215 15.891 5.45399C16 5.24008 16 4.96005 16 4.4V3.6C16 3.03995 16 2.75992 15.891 2.54601C15.7951 2.35785 15.6422 2.20487 15.454 2.10899C15.2401 2 14.9601 2 14.4 2H9.6C9.03995 2 8.75992 2 8.54601 2.10899C8.35785 2.20487 8.20487 2.35785 8.10899 2.54601C8 2.75992 8 3.03995 8 3.6V4.4C8 4.96005 8 5.24008 8.10899 5.45399C8.20487 5.64215 8.35785 5.79513 8.54601 5.89101C8.75992 6 9.03995 6 9.6 6Z",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        }),
        title: "SOC II certified",
        description: "SOC II certified to ensure reliability and data processing integrity."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M13.7316 13.1947C13.661 12.9831 13.6257 12.8772 13.6276 12.7907C13.6295 12.6996 13.6417 12.6519 13.6836 12.5711C13.7235 12.4942 13.83 12.395 14.0432 12.1967C14.6318 11.649 15 10.8675 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 10.8675 9.36818 11.649 9.95681 12.1967C10.17 12.395 10.2765 12.4942 10.3164 12.5711C10.3583 12.6519 10.3705 12.6996 10.3724 12.7907C10.3743 12.8772 10.339 12.9831 10.2684 13.1947L9.35099 15.947C9.23249 16.3025 9.17324 16.4803 9.20877 16.6218C9.23987 16.7456 9.31718 16.8529 9.42484 16.9216C9.54783 17 9.7352 17 10.1099 17H13.8901C14.2648 17 14.4522 17 14.5752 16.9216C14.6828 16.8529 14.7601 16.7456 14.7912 16.6218C14.8268 16.4803 14.7675 16.3025 14.649 15.947L13.7316 13.1947Z",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                })
            ]
        }),
        title: "GDPR and CCPA compliance",
        description: "GDPR and CCPA compliant communities with a built-in policy and guidelines tool."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 4C16.93 4 17.395 4 17.7765 4.10222C18.8117 4.37962 19.6204 5.18827 19.8978 6.22354C20 6.60504 20 7.07003 20 8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V8C4 7.07003 4 6.60504 4.10222 6.22354C4.37962 5.18827 5.18827 4.37962 6.22354 4.10222C6.60504 4 7.07003 4 8 4M9 15L11 17L15.5 12.5M9.6 6H14.4C14.9601 6 15.2401 6 15.454 5.89101C15.6422 5.79513 15.7951 5.64215 15.891 5.45399C16 5.24008 16 4.96005 16 4.4V3.6C16 3.03995 16 2.75992 15.891 2.54601C15.7951 2.35785 15.6422 2.20487 15.454 2.10899C15.2401 2 14.9601 2 14.4 2H9.6C9.03995 2 8.75992 2 8.54601 2.10899C8.35785 2.20487 8.20487 2.35785 8.10899 2.54601C8 2.75992 8 3.03995 8 3.6V4.4C8 4.96005 8 5.24008 8.10899 5.45399C8.20487 5.64215 8.35785 5.79513 8.54601 5.89101C8.75992 6 9.03995 6 9.6 6Z",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        }),
        title: "Custom SSO",
        description: "Fully control the community access and allow customers with existing credentials to log in."
    }, 
];
var EntrpriseFeatures_training_supports = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.09436 11.2288C6.03221 10.8282 5.99996 10.4179 5.99996 10C5.99996 5.58172 9.60525 2 14.0526 2C18.4999 2 22.1052 5.58172 22.1052 10C22.1052 10.9981 21.9213 11.9535 21.5852 12.8345C21.5154 13.0175 21.4804 13.109 21.4646 13.1804C21.4489 13.2512 21.4428 13.301 21.4411 13.3735C21.4394 13.4466 21.4493 13.5272 21.4692 13.6883L21.8717 16.9585C21.9153 17.3125 21.9371 17.4895 21.8782 17.6182C21.8266 17.731 21.735 17.8205 21.6211 17.8695C21.4911 17.9254 21.3146 17.8995 20.9617 17.8478L17.7765 17.3809C17.6101 17.3565 17.527 17.3443 17.4512 17.3448C17.3763 17.3452 17.3245 17.3507 17.2511 17.3661C17.177 17.3817 17.0823 17.4172 16.893 17.4881C16.0097 17.819 15.0524 18 14.0526 18C13.6344 18 13.2237 17.9683 12.8227 17.9073M7.63158 22C10.5965 22 13 19.5376 13 16.5C13 13.4624 10.5965 11 7.63158 11C4.66668 11 2.26316 13.4624 2.26316 16.5C2.26316 17.1106 2.36028 17.6979 2.53955 18.2467C2.61533 18.4787 2.65322 18.5947 2.66566 18.6739C2.67864 18.7567 2.68091 18.8031 2.67608 18.8867C2.67145 18.9668 2.65141 19.0573 2.61134 19.2383L2 22L4.9948 21.591C5.15827 21.5687 5.24 21.5575 5.31137 21.558C5.38652 21.5585 5.42641 21.5626 5.50011 21.5773C5.5701 21.5912 5.67416 21.6279 5.88227 21.7014C6.43059 21.8949 7.01911 22 7.63158 22Z",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        }),
        title: "Training and onboarding",
        description: "With clear guidelines on what needs to be done, your team is fully equipped to drive a successful community project."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 17.5H3.5M6.5 12H2M9 6.5H4M17 3L10.4036 12.235C10.1116 12.6438 9.96562 12.8481 9.97194 13.0185C9.97744 13.1669 10.0486 13.3051 10.1661 13.3958C10.3011 13.5 10.5522 13.5 11.0546 13.5H16L15 21L21.5964 11.765C21.8884 11.3562 22.0344 11.1519 22.0281 10.9815C22.0226 10.8331 21.9514 10.6949 21.8339 10.6042C21.6989 10.5 21.4478 10.5 20.9454 10.5H16L17 3Z",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        }),
        title: "Priority support",
        description: "Know that you can always count on our support team to have your back and resolve issues on high priority."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V13M12 8H16V12M15.5 3.5V2M19.4393 4.56066L20.5 3.5M20.5103 8.5H22.0103M3 13.3471C3.65194 13.4478 4.31987 13.5 5 13.5C9.38636 13.5 13.2653 11.3276 15.6197 8",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        }),
        title: "Customer success",
        description: "Build, reach, and exceed your business goals with curated playbooks and checklists, crafted by our team of community experts."
    }, 
];
var EntrpriseFeatures_enterprise_features = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M21 3H3",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12 21V7",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M5 14L12 7L19 14",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                })
            ]
        }),
        title: "Power that scales",
        description: "Tradly Enterprise is designed to service large communities without sacrificing reliability."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 3L10.4036 12.235C10.1116 12.6438 9.96562 12.8481 9.97194 13.0185C9.97744 13.1669 10.0486 13.3051 10.1661 13.3958C10.3011 13.5 10.5522 13.5 11.0546 13.5H16L15 21L21.5964 11.765C21.8884 11.3562 22.0344 11.1519 22.0281 10.9815C22.0226 10.8331 21.9514 10.6949 21.8339 10.6042C21.6989 10.5 21.4478 10.5 20.9454 10.5H16L17 3Z",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        }),
        title: "High-speed experience",
        description: "Get your community members hooked with high-speed browsing experience that is designed for scale."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M20 10V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M16.9973 14.8306C16.1975 13.9216 14.8639 13.6771 13.8619 14.5094C12.8599 15.3418 12.7188 16.7335 13.5057 17.7179C14.2926 18.7024 16.9973 21 16.9973 21C16.9973 21 19.7019 18.7024 20.4888 17.7179C21.2757 16.7335 21.1519 15.3331 20.1326 14.5094C19.1134 13.6858 17.797 13.9216 16.9973 14.8306Z",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12.5 11H8",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M9 15H8",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M16 7H8",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                })
            ]
        }),
        title: "Uptime SLA",
        description: "Get guaranteed uptime, offer a seamless community experience to the members, and protect your brand reputation."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V13.5C21 14.8978 21 15.5967 20.7716 16.1481C20.4672 16.8831 19.8831 17.4672 19.1481 17.7716C18.5967 18 17.8978 18 16.5 18V18C16.0114 18 15.7671 18 15.5405 18.0535C15.2383 18.1248 14.9569 18.2656 14.7185 18.4645C14.5397 18.6137 14.3931 18.8091 14.1 19.2L12.64 21.1467C12.4229 21.4362 12.3143 21.5809 12.1812 21.6327C12.0647 21.678 11.9353 21.678 11.8188 21.6327C11.6857 21.5809 11.5771 21.4362 11.36 21.1467L9.9 19.2C9.60685 18.8091 9.46028 18.6137 9.28149 18.4645C9.04312 18.2656 8.76169 18.1248 8.45951 18.0535C8.23287 18 7.98858 18 7.5 18V18C6.10218 18 5.40326 18 4.85195 17.7716C4.11687 17.4672 3.53284 16.8831 3.22836 16.1481C3 15.5967 3 14.8978 3 13.5V7.8Z",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.5 10.5H7.51M8 10.5C8 10.7761 7.77614 11 7.5 11C7.22386 11 7 10.7761 7 10.5C7 10.2239 7.22386 10 7.5 10C7.77614 10 8 10.2239 8 10.5Z",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12 10.5H12.01M12.5 10.5C12.5 10.7761 12.2761 11 12 11C11.7239 11 11.5 10.7761 11.5 10.5C11.5 10.2239 11.7239 10 12 10C12.2761 10 12.5 10.2239 12.5 10.5Z",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M16.5 10.5H16.51M17 10.5C17 10.7761 16.7761 11 16.5 11C16.2239 11 16 10.7761 16 10.5C16 10.2239 16.2239 10 16.5 10C16.7761 10 17 10.2239 17 10.5Z",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                })
            ]
        }),
        title: "Connect with customers",
        description: "Solve a problem or close a sale in real-time with chat. If no one is available, customers are seamlessly routed to email without confusion."
    }, 
];
var EntrpriseFeatures_enterprise_ads_features = [
    {
        title: "Guaranteed SLA",
        description: "Consistent uptime and performance with our service level agreement.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 12.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M14 11H8M10 15H8M16 7H8M14.5 19L16.5 21L21 16.5",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        })
    },
    {
        title: "Data Residency",
        description: "Control where your data is stored for compliance and performance.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.68675 15.6451L4.59494 14.5435C4.6983 14.4839 4.8196 14.4631 4.9369 14.4851L8.6914 15.1878C8.99995 15.2455 9.28478 15.008 9.28338 14.6941L9.26876 11.4045C9.26836 11.3151 9.29193 11.2272 9.33701 11.15L11.2317 7.90621C11.3303 7.73739 11.3215 7.52658 11.2091 7.3666L8.01892 2.82568M19.0002 4.85905C13.5002 7.50004 16.5 11 17.5002 11.5C19.3773 12.4384 21.9876 12.5 21.9876 12.5C21.9958 12.3344 22 12.1677 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C12.1677 22 12.3344 21.9959 12.5 21.9877M16.7578 21.9398L13.591 13.591L21.9398 16.7578L18.2376 18.2376L16.7578 21.9398Z",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        })
    },
    {
        title: "SOC Type 2",
        description: "Verified security controls for data protection and privacy standards.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 7.49987L10 10.4999L14 12.4999L11 15.4999M20 11.9999C20 16.9083 14.646 20.4783 12.698 21.6147C12.4766 21.7439 12.3659 21.8085 12.2097 21.842C12.0884 21.868 11.9116 21.868 11.7903 21.842C11.6341 21.8085 11.5234 21.7439 11.302 21.6147C9.35396 20.4783 4 16.9083 4 11.9999V7.21747C4 6.41796 4 6.0182 4.13076 5.67457C4.24627 5.37101 4.43398 5.10015 4.67766 4.8854C4.9535 4.64231 5.3278 4.50195 6.0764 4.22122L11.4382 2.21054C11.6461 2.13258 11.75 2.0936 11.857 2.07815C11.9518 2.06444 12.0482 2.06444 12.143 2.07815C12.25 2.0936 12.3539 2.13258 12.5618 2.21054L17.9236 4.22122C18.6722 4.50195 19.0465 4.64231 19.3223 4.8854C19.566 5.10015 19.7537 5.37101 19.8692 5.67457C20 6.0182 20 6.41796 20 7.21747V11.9999Z",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        })
    },
    {
        title: "Dedicated account support",
        description: "Personalized assistance with a dedicated expert",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.5 12.5C8.5 12.5 9.8125 14 12 14C14.1875 14 15.5 12.5 15.5 12.5M14.75 7.5H14.76M9.25 7.5H9.26M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18ZM15.25 7.5C15.25 7.77614 15.0261 8 14.75 8C14.4739 8 14.25 7.77614 14.25 7.5C14.25 7.22386 14.4739 7 14.75 7C15.0261 7 15.25 7.22386 15.25 7.5ZM9.75 7.5C9.75 7.77614 9.52614 8 9.25 8C8.97386 8 8.75 7.77614 8.75 7.5C8.75 7.22386 8.97386 7 9.25 7C9.52614 7 9.75 7.22386 9.75 7.5Z",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        })
    }, 
];
var EntrpriseFeatures_customizing_features = [
    {
        title: "Blocks & Layout",
        description: "Go beyond basic branding. Select, arrange, and configure Blocks to build your unique layout with zero coding.",
        image: "https://media.tradly.app/images/marketplace/38566/Tradly-Marketplace---Home-Page-Xb3nK2CI.png"
    },
    {
        title: "Apps & Integrations",
        description: "Build a community that functions the way you want. Pick apps from the App Store, or build your custom apps to breathe life into your unique ideas.",
        image: "https://media.tradly.app/images/marketplace/38566/Tradly-Marketplace---Home-Page-Xb3nK2CI.png"
    },
    {
        title: "Embeddable widgets",
        description: "Easily embed your community into your existing app or website to improve access to self-service resources and peer-to-peer support.",
        image: "https://media.tradly.app/images/marketplace/38566/Tradly-Marketplace---Home-Page-Xb3nK2CI.png"
    }, 
];

;// CONCATENATED MODULE: ./src/components/Tradly/Pricing/EnterPrise/SupportFeatureCard.jsx



var SupportFeatureCard = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: " w-full ",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: " w-full flex flex-col gap-3 md:gap-4 mb-12 md:mb-[72px]",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: " text-base font-semibold text-primary",
                        children: "Support"
                    }),
                    /*#__PURE__*/ _jsx("h2", {
                        className: "h2",
                        children: "Best in class security and compliance"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: " text-lightGray text-[18px] font-medium leading-[27px] max-w-screen-md mr-0",
                        children: "Tradly protects sensitive data and keeps member information secure with enterprise-grade data protection, compliance best practices, and top-notch cloud service standards."
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: " grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-10 md:gap-y-12",
                children: support_features.map(function(feature) {
                    return /*#__PURE__*/ _jsxs("div", {
                        className: " flex items-start justify-start flex-col",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: " mb-6 flex items-center justify-center text-primary h-10 w-10 bg-primary/40 ring-8 ring-primary/10 rounded-full ",
                                children: feature.icon
                            }),
                            /*#__PURE__*/ _jsxs("h4", {
                                className: " h4 mb-2",
                                children: [
                                    feature.title,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-lightGray text-base font-medium leading-[24px]",
                                children: feature.description
                            })
                        ]
                    });
                })
            })
        ]
    });
};
/* harmony default export */ var EnterPrise_SupportFeatureCard = ((/* unused pure expression or super */ null && (SupportFeatureCard)));

;// CONCATENATED MODULE: ./src/components/Tradly/Pricing/EnterPrise/TrainingSupportFeatureCard.jsx



var TrainingSupportFeatureCard = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: " w-full ",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: " w-full flex flex-col md:items-center md:justify-center gap-3 md:gap-4 mb-12 md:mb-[72px] ",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: " text-base font-semibold text-primary md:text-center",
                        children: "Support"
                    }),
                    /*#__PURE__*/ _jsx("h2", {
                        className: "h2 text-center",
                        children: "Obsessed with your success"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: " text-lightGray text-[18px] font-medium leading-[27px] max-w-screen-md mr-0 md:text-center",
                        children: "Tradly's customer success team becomes an extension of your team. We offer strategic guidance as well as training. And our support team always has your back, so rest assured and end enjoy high-priority help."
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: " grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-10 md:gap-y-12",
                children: training_supports.map(function(feature) {
                    return /*#__PURE__*/ _jsxs("div", {
                        className: " flex items-start md:justify-center flex-col md:text-center",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: " mb-6 flex items-center justify-center text-primary h-10 w-10 bg-primary/40 ring-8 ring-primary/10 rounded-full md:mx-auto ",
                                children: feature.icon
                            }),
                            /*#__PURE__*/ _jsxs("h4", {
                                className: " h4 mb-2 text-center md:mx-auto",
                                children: [
                                    feature.title,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-lightGray text-base font-medium leading-[24px]",
                                children: feature.description
                            })
                        ]
                    });
                })
            })
        ]
    });
};
/* harmony default export */ var EnterPrise_TrainingSupportFeatureCard = ((/* unused pure expression or super */ null && (TrainingSupportFeatureCard)));

;// CONCATENATED MODULE: ./src/components/Tradly/Pricing/EnterPrise/ReviewCard.jsx


var ReviewCard = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: " w-full bg-[#f8fafc] px-6 py-10 md:p-16 rounded-2xl text-center flex flex-col gap-4 items-center ",
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "sm_h3 md:h3 !font-medium",
                children: "“We love Tradly because it offers our members a distraction-free place to network, learn and grow their business.”"
            }),
            /*#__PURE__*/ _jsx("img", {
                src: "https://media.tradly.app/images/marketplace/47432/image-18-qoziCqvM.png",
                alt: "",
                className: " w-14 h-14 rounded-full"
            }),
            /*#__PURE__*/ _jsx("p", {
                className: " text-lg font-bold",
                children: "Jennifer Lee"
            }),
            /*#__PURE__*/ _jsx("p", {
                className: " font-medium text-lightGray",
                children: "Customer Success and Community Manager, WebinarNinja"
            })
        ]
    });
};
/* harmony default export */ var EnterPrise_ReviewCard = ((/* unused pure expression or super */ null && (ReviewCard)));

;// CONCATENATED MODULE: ./src/components/Tradly/Pricing/EnterPrise/EnterpriseFeatures.jsx



var EnterpriseFeatures = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: " w-full grid grid-cols-1 md:grid-cols-2 gap-16 ",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: " hidden md:block",
                children: /*#__PURE__*/ _jsx("img", {
                    src: "https://media.tradly.app/images/marketplace/39213/63646bfbbb5bde334da8f176_mohammad-rahmani-N5bT5RctFZ8-unsplash-p-1080-kwSpKrJV.webp",
                    alt: "",
                    className: " rounded-r-lg"
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: " w-full",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: " w-full flex flex-col gap-3 md:gap-4 mb-8",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: " text-base font-semibold text-primary",
                                children: "Scale"
                            }),
                            /*#__PURE__*/ _jsx("h2", {
                                className: "h2 mx-auto md:mx-0",
                                children: "Grow with confidence"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: " text-lightGray text-[18px] font-medium leading-[27px] max-w-screen-md mr-0",
                                children: "Tradly Enterprise is uniquely suited to the needs of large communities while ensuring stellar customer experience."
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: " grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-10 md:gap-y-12",
                        children: enterprise_features.map(function(feature) {
                            return /*#__PURE__*/ _jsxs("div", {
                                className: " flex items-start justify-start flex-col p-[10px] pl-[14px] ",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: " mb-6 flex items-center justify-center text-primary h-10 w-10 bg-primary/40 ring-8 ring-primary/10 rounded-full ",
                                        children: feature.icon
                                    }),
                                    /*#__PURE__*/ _jsxs("h4", {
                                        className: " h4 mb-2",
                                        children: [
                                            feature.title,
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "text-lightGray text-base font-medium leading-[24px]",
                                        children: feature.description
                                    })
                                ]
                            });
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var EnterPrise_EnterpriseFeatures = ((/* unused pure expression or super */ null && (EnterpriseFeatures)));

;// CONCATENATED MODULE: ./src/components/Tradly/Pricing/EnterPrise/EnterpriseAdsFeatures.jsx



var EnterpriseAdsFeatures = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: " w-full grid grid-cols-1 md:grid-cols-2 gap-16 bg-[#fbf4ff] px-6 py-10 md:p-16 rounded-2xl items-center ",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: " flex flex-col gap-4 items-start order-last md:order-none ",
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        className: " h3 !text-[30px]",
                        children: "Tradly for Enterprise"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: " text-lightGray text-[18px] font-medium leading-[27px] max-w-screen-md mr-0",
                        children: "Tailored for excellence in scalability, security, and support."
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: " w-full flex flex-col md:flex-row items-center justify-start gap-3 mt-2 md:mt-4",
                        children: [
                            /*#__PURE__*/ _jsx("button", {
                                className: " btn_blue_primary !w-full md:!w-auto !rounded-full",
                                children: "Contact Sales"
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                className: " btn_white_primary !w-full md:!w-auto !rounded-full",
                                children: "Learn More"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: " w-full",
                children: /*#__PURE__*/ _jsx("div", {
                    className: " grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-10 md:gap-y-12",
                    children: enterprise_ads_features.map(function(feature) {
                        return /*#__PURE__*/ _jsxs("div", {
                            className: " flex items-start justify-start flex-col ",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: " mb-6 flex items-center justify-center text-periwinkle_blue h-10 w-10 bg-[#f3eaff] ring-8 ring-white rounded-full ",
                                    children: feature.icon
                                }),
                                /*#__PURE__*/ _jsxs("h4", {
                                    className: " text-lg font-bold text-dark_black mb-2",
                                    children: [
                                        feature.title,
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "text-lightGray text-sm font-medium leading-[21px]",
                                    children: feature.description
                                })
                            ]
                        });
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var EnterPrise_EnterpriseAdsFeatures = ((/* unused pure expression or super */ null && (EnterpriseAdsFeatures)));

;// CONCATENATED MODULE: ./src/components/Tradly/Pricing/EnterPrise/IntegrationsAdsCard.jsx


var IntegrationsAdsCard = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: " w-full grid grid-cols-1 md:grid-cols-2 gap-16 items-center ",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: " w-full grid grid-cols-4 gap-4 md:gap-8 lg:p-8 order-last md:order-none ",
                children: [
                    /*#__PURE__*/ _jsx("img", {
                        src: "https://media.tradly.app/images/marketplace/38667/633c70941b737616aefef393_mailchimp-logo-qRSCyh5k.svg",
                        alt: ""
                    }),
                    /*#__PURE__*/ _jsx("img", {
                        src: "https://media.tradly.app/images/marketplace/87037/633c7424ec242a1e4cfa8fc6_fullstory-logo-ZQVN4GNA.svg",
                        alt: ""
                    }),
                    /*#__PURE__*/ _jsx("img", {
                        src: "https://media.tradly.app/images/marketplace/23695/633c7010d2304ea97e6d2f88_google-analytics-Zn32OIEe.svg",
                        alt: ""
                    }),
                    /*#__PURE__*/ _jsx("img", {
                        src: "https://media.tradly.app/images/marketplace/14534/633c774f5eac62641b959747_hubspot-logo-wmziH2v6.svg",
                        alt: ""
                    }),
                    /*#__PURE__*/ _jsx("img", {
                        src: "https://media.tradly.app/images/marketplace/75784/633c76f094127552993360dd_intercom-logo-cyt1Bvrq.svg",
                        alt: ""
                    }),
                    /*#__PURE__*/ _jsx("img", {
                        src: "https://media.tradly.app/images/marketplace/67281/633c71fedaf66147e89c2835_amplitude-logo-AL5gOlRr.svg",
                        alt: ""
                    }),
                    /*#__PURE__*/ _jsx("img", {
                        src: "https://media.tradly.app/images/marketplace/87363/62d0d46f68ea16d26a2154ef_zapier-vcnaheYu.svg",
                        alt: ""
                    }),
                    /*#__PURE__*/ _jsx("img", {
                        src: "https://media.tradly.app/images/marketplace/11466/633c7398eb8f2c9b1f0cb12a_mixpanel-logo-FF60WZ0d.svg",
                        alt: ""
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: " flex flex-col gap-4 items-start ",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: " text-primary bg-primary/20 px-2 rounded-full text-sm font-medium",
                        children: "Integrations"
                    }),
                    /*#__PURE__*/ _jsx("h3", {
                        className: " h3 ",
                        children: "Connect all your apps"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: " text-lightGray text-[18px] font-medium leading-[27px] max-w-screen-md mr-0",
                        children: "Get more value out of your tools with a variety of direct integrations, extensible APIs, webhooks, and custom scripting."
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: " flex flex-col mt-2 md:mt-4",
                        children: /*#__PURE__*/ _jsx("button", {
                            className: " btn_white_primary !rounded-full",
                            children: "All Integrations"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var EnterPrise_IntegrationsAdsCard = ((/* unused pure expression or super */ null && (IntegrationsAdsCard)));

;// CONCATENATED MODULE: ./src/components/Tradly/Pricing/EnterPrise/CustomizingFeatures.jsx



var CustomizingFeatures = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: " w-full ",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: " w-full flex flex-col gap-3 md:gap-4 mb-12 md:mb-[72px]",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: " text-base font-semibold text-primary",
                        children: "Features"
                    }),
                    /*#__PURE__*/ _jsx("h2", {
                        className: "h2",
                        children: "Customize Everything"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: " text-lightGray text-[18px] font-medium leading-[27px] max-w-screen-md mr-0",
                        children: "Engage your customers, enhance their experience, and win them for life!"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: " grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-10 md:gap-y-12",
                children: customizing_features.map(function(feature) {
                    return /*#__PURE__*/ _jsxs("div", {
                        className: " flex items-start justify-start flex-col",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: " mb-6 w-full h-fit bg-#f1f3f7 ",
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: feature === null || feature === void 0 ? void 0 : feature.image,
                                    loading: "lazy",
                                    sizes: "(max-width: 479px) 93vw, (max-width: 767px) 96vw, (max-width: 991px) 29vw, (max-width: 1439px) 30vw, 405.3359375px",
                                    alt: "Mockup",
                                    class: "layout73_image"
                                })
                            }),
                            /*#__PURE__*/ _jsxs("h4", {
                                className: " h4 !text-[20px] mb-2",
                                children: [
                                    feature.title,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-lightGray text-base font-medium leading-[24px]",
                                children: feature.description
                            })
                        ]
                    });
                })
            })
        ]
    });
};
/* harmony default export */ var EnterPrise_CustomizingFeatures = ((/* unused pure expression or super */ null && (CustomizingFeatures)));

;// CONCATENATED MODULE: ./src/components/Tradly/Pricing/EnterPrise/TermToggle.jsx


var TermToggle_TermToggle = function(param) {
    var is_long_term = param.is_long_term, setIsLongTerm = param.setIsLongTerm;
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative flex w-full py-2.5 bg-gray-200 rounded-t-2xl",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "absolute inset-0 m-1 pointer-events-none",
                "aria-hidden": "true",
                children: /*#__PURE__*/ _jsx("span", {
                    className: "absolute inset-0 w-1/2 bg-white rounded-lg shadow transform transition duration-150 ease-in-out ".concat(!is_long_term ? "translate-x-0" : "translate-x-full")
                })
            }),
            /*#__PURE__*/ _jsx("button", {
                className: "relative flex-1 text-sm font-medium p-1 transition duration-150 ease-in-out ".concat(is_long_term && "text-gray-500"),
                onClick: function(e) {
                    e.preventDefault();
                    setIsLongTerm(false);
                },
                children: "1-year term"
            }),
            /*#__PURE__*/ _jsx("button", {
                className: "relative flex-1 text-sm font-medium p-1 transition duration-150 ease-in-out ".concat(!is_long_term && "text-gray-500"),
                onClick: function(e) {
                    e.preventDefault();
                    setIsLongTerm(true);
                },
                children: "3-year term"
            })
        ]
    });
};
/* harmony default export */ var EnterPrise_TermToggle = ((/* unused pure expression or super */ null && (TermToggle_TermToggle)));

;// CONCATENATED MODULE: ./src/components/Tradly/Pricing/EnterPrise/TermOptions.jsx



var TermOptions = function() {
    var ref = useState(false), is_long_term = ref[0], setIsLongTerm = ref[1];
    return /*#__PURE__*/ _jsxs("div", {
        className: " w-full bg-white md:p-8 rounded-3xl grid grid-cols-1 md:grid-cols-2 gap-6 items-center shadow-md",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: " w-full flex flex-col gap-4 p-4 md:p-0",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: " text-base font-bold text-black",
                        children: " Term options"
                    }),
                    /*#__PURE__*/ _jsx("h2", {
                        className: "h2",
                        children: "Invest in your growth with competitive rates"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: " text-lightGray text-[18px] font-medium leading-[27px] max-w-screen-md mr-0",
                        children: "Exclusive features, advanced conversion tools, and the lowest transaction fees* on Shopify—it’s all part of your plan."
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: " text-lightGray text-sm font-medium leading-[27px] max-w-screen-md md:mt-16 italic",
                        children: "*Transaction fees and credit card rates vary by region."
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: " bg-[#f8fafc] p-4 md:p-8 w-full h-full",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: " w-full h-full bg-white shadow-lg rounded-2xl",
                    children: [
                        /*#__PURE__*/ _jsx(TermToggle, {
                            is_long_term: is_long_term,
                            setIsLongTerm: setIsLongTerm
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: " p-8 flex flex-col gap-2",
                            children: [
                                /*#__PURE__*/ _jsxs("p", {
                                    className: "text-base font-bold text-black",
                                    children: [
                                        "Starting at ",
                                        is_long_term ? /*#__PURE__*/ _jsx("span", {
                                            className: " line-through",
                                            children: "$9,500"
                                        }) : ""
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: " flex items-end justify-start gap-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("h1", {
                                            className: "h1",
                                            children: is_long_term ? "$2,300" : "$2,500"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: " font-sm font-ormal text-lightGray",
                                            children: "USD/month"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "text-lightGray text-[18px] font-medium leading-[27px] mt-2",
                                    children: "or a variable platform fee for more complex business structures"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var EnterPrise_TermOptions = ((/* unused pure expression or super */ null && (TermOptions)));

;// CONCATENATED MODULE: ./src/components/Tradly/Pricing/EnterPrise/HeroBanner.jsx


var HeroBanner = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: " w-full grid grid-cols-1 md:grid-cols-2 gap-16 items-center ",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: " flex flex-col gap-4 items-start ",
                children: [
                    /*#__PURE__*/ _jsx("h1", {
                        className: " h1 ",
                        children: "Flexible and scalable engagement platform"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: " text-lightGray text-[18px] font-medium leading-[27px] max-w-screen-md mr-0",
                        children: "Bettermode is customizable, scalable, and secure. It’s a platform trusted by community-led businesses. And Bettermode is here to help you."
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: " flex flex-col mt-2 md:mt-4",
                        children: /*#__PURE__*/ _jsx("button", {
                            className: " btn_primary !py-4 !px-7 !rounded-full",
                            children: "Book a Demo"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: " w-full h-full ",
                children: /*#__PURE__*/ _jsx("img", {
                    src: "https://media.tradly.app/images/marketplace/99874/636358a162f1de7c2d7bc417_feature-index-06-p-1080-KiMlI9Yc.webp",
                    loading: "lazy",
                    width: "1623",
                    sizes: "(max-width: 479px) 100vw, (max-width: 767px) 96vw, (max-width: 991px) 94vw, 1072px",
                    alt: "MacBook mockup",
                    className: " w-full h-full object-contain"
                })
            })
        ]
    });
};
/* harmony default export */ var EnterPrise_HeroBanner = ((/* unused pure expression or super */ null && (HeroBanner)));

;// CONCATENATED MODULE: ./src/components/Tradly/Pricing/EnterPrise/EnterpriseComingSoon.jsx




var EnterpriseComingSoon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: " w-full grid grid-cols-1 md:grid-cols-2 gap-16 bg-[#E8FFFA] px-6 py-10 md:p-16 rounded-2xl items-center ",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: " flex flex-col gap-4 items-start order-last md:order-none ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: " h3 !text-[30px]",
                    children: "Customized plans for enterprise "
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: " text-lightGray text-[18px] font-medium leading-[27px] max-w-screen-md mr-0",
                    children: "Customised service to meet the needs of enterprises. Everything managed with additional services."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " w-full flex flex-col md:flex-row items-center justify-start gap-3 mt-2 md:mt-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/support",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: " btn_primary !w-full md:!w-auto !rounded-full",
                            children: "Contact Sales"
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var EnterPrise_EnterpriseComingSoon = (EnterpriseComingSoon);

;// CONCATENATED MODULE: ./src/components/Tradly/Pricing/EnterPrisePricng.jsx













var EnterPrisePricing = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: " w-dull flex flex-col gap-10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EnterPrise_EnterpriseComingSoon, {})
    });
};
/* harmony default export */ var EnterPrisePricng = (EnterPrisePricing);

;// CONCATENATED MODULE: ./src/components/Tradly/Pricing/SMEPricingModel2.jsx





var SMEPricingModel2 = function(param) {
    var is_annual = param.is_annual, userDetails = param.userDetails, tenantDetails = param.tenantDetails;
    return /*#__PURE__*/ _jsx("div", {
        className: " grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[11px]",
        children: pricing_plans === null || pricing_plans === void 0 ? void 0 : pricing_plans.map(function(item, index) {
            var ref, ref1;
            return /*#__PURE__*/ _jsxs("div", {
                className: "relative flex flex-col h-full py-8 px-6 rounded-2xl bg-white shadow-xl  border border-[#eaecf0] ",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: " flex items-center justify-between mb-2",
                                children: [
                                    /*#__PURE__*/ _jsx("h2", {
                                        className: "h2 !text-2xl !font-semibold",
                                        children: item === null || item === void 0 ? void 0 : item.title
                                    }),
                                    (item === null || item === void 0 ? void 0 : item.is_show_star) && /*#__PURE__*/ _jsx("p", {
                                        className: " text-sm px-2 text-primary bg-primary/20 rounded-2xl",
                                        children: "Popular"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: " text-lightGray text-sm font-medium leading-[27px] min-h-[108px] text",
                                children: item === null || item === void 0 ? void 0 : item.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("hr", {
                        className: "my-8 w-full h-[1px] bg-[#eaecf0]"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "inline-flex items-baseline my-2",
                        children: [
                            /*#__PURE__*/ _jsxs("h3", {
                                className: "h3",
                                children: [
                                    item === null || item === void 0 ? void 0 : (ref = item.price) === null || ref === void 0 ? void 0 : ref.dollar_sign,
                                    is_annual ? item.price.true : item.price.false
                                ]
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "text-gray-900 text-sm font-semibold ml-1",
                                children: "USD"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: " text-lightGray text-sm font-medium",
                        children: "per month"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: " text-lightGray text-sm font-medium",
                        children: is_annual ? "billed yearly" : "billed monthly"
                    }),
                    /*#__PURE__*/ _jsx("hr", {
                        className: "my-8 w-full h-[1px] bg-[#eaecf0]"
                    }),
                    /*#__PURE__*/ _jsx("ul", {
                        className: "text-gray-900 -mb-2 flex-grow flex flex-col gap-4",
                        children: item === null || item === void 0 ? void 0 : (ref1 = item.features) === null || ref1 === void 0 ? void 0 : ref1.map(function(feature) {
                            return /*#__PURE__*/ _jsxs("li", {
                                className: "flex items-center gap-3 ",
                                children: [
                                    /*#__PURE__*/ _jsxs("svg", {
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ _jsx("path", {
                                                d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
                                                fill: "#D1FADF"
                                            }),
                                            /*#__PURE__*/ _jsx("path", {
                                                "fill-rule": "evenodd",
                                                "clip-rule": "evenodd",
                                                d: "M17.096 7.39004L9.93602 14.3L8.03602 12.27C7.68602 11.94 7.13602 11.92 6.73602 12.2C6.34602 12.49 6.23602 13 6.47602 13.41L8.72602 17.07C8.94602 17.41 9.32601 17.62 9.75601 17.62C10.166 17.62 10.556 17.41 10.776 17.07C11.136 16.6 18.006 8.41004 18.006 8.41004C18.906 7.49004 17.816 6.68004 17.096 7.38004V7.39004Z",
                                                fill: "#12B76A"
                                            })
                                        ]
                                    }),
                                    (feature === null || feature === void 0 ? void 0 : feature.link) ? /*#__PURE__*/ _jsx(Link, {
                                        href: feature === null || feature === void 0 ? void 0 : feature.link,
                                        children: /*#__PURE__*/ _jsx("a", {
                                            className: "text-lightGray text-sm font-medium flex-grow underline",
                                            children: feature === null || feature === void 0 ? void 0 : feature.title
                                        })
                                    }) : /*#__PURE__*/ _jsx("span", {
                                        className: "text-lightGray text-sm font-medium flex-grow",
                                        children: feature === null || feature === void 0 ? void 0 : feature.title
                                    }),
                                    (feature === null || feature === void 0 ? void 0 : feature.info) && /*#__PURE__*/ _jsxs("div", {
                                        className: "ml-1 group",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: " cursor-pointer",
                                                children: info_icon
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: " hidden absolute group-hover:block bg-gray-600 text-gray-50 text-sm mt-2 text-start p-2 z-20 rounded-md max-w-xs w-full right-0",
                                                children: feature === null || feature === void 0 ? void 0 : feature.info
                                            })
                                        ]
                                    })
                                ]
                            });
                        })
                    })
                ]
            });
        })
    });
};
/* harmony default export */ var Pricing_SMEPricingModel2 = ((/* unused pure expression or super */ null && (SMEPricingModel2)));

;// CONCATENATED MODULE: ./src/components/Tradly/Pricing/SMBPricingBlocks.jsx





var SMBPricingBlocks = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialPlans/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-12 md:h-20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturesTable/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-3xl mx-auto space-y-5 pt-20 pb-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " border-t border-gray-200"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "h2 text-center",
                        children: "How Does Tradly Pricing Work"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "max-w-3xl mx-auto pl-12 list-decimal space-y-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Base Cost shown above for the Hosted Backend. This includes the Tradly Headless API which stores your data and run your business operations. Hosting, Maintenace, Security and Updates."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "+ Front end Templates."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "max-w-3xl mx-auto pl-12 list-disc mt-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "A. Websites - Free Templates by Tradly or Paid Templates from Partners. "
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "B. Mobile Apps - Optionally you can buy app source code in Tradly Marketplace."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Optional Add Ons"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faqs/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var Pricing_SMBPricingBlocks = (SMBPricingBlocks);

;// CONCATENATED MODULE: ./src/components/Tradly/marketplace/PricingTablesMarketplace.js

















function PricingTablesMarketplace() {
    var ref = (0,react.useState)(true), is_yearly = ref[0], setIsYearly = ref[1];
    var ref1 = (0,react.useState)(false), is_business_model = ref1[0], setISBusinessModel = ref1[1];
    var ref2 = (0,react.useState)(null), userDetails = ref2[0], setUserDetails = ref2[1];
    var ref3 = (0,react.useState)(null), tenantDetails = ref3[0], setTenantDetails = ref3[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        if ((0,functions.getAuthKey)() !== undefined) {
            User_store_default().user_details(function(resp) {
                setUserDetails(resp);
            });
            User_store_default().tenant_details(function(resp) {
                setTenantDetails(resp);
            });
        }
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-gradient-to-b from-white to-gray-100",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-w-7xl w-full mx-auto px-4 sm:px-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: " pb-12 pt-16 md:pb-20",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "max-w-3xl mx-auto text-center pb-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "h1 mb-4 text-gray-900 ",
                                        "data-aos": "zoom-y-out",
                                        children: "Flexible Pricing for everyone."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-xl text-gray-900",
                                        "data-aos": "zoom-y-out",
                                        "data-aos-delay": "150",
                                        children: "Tradly Platform comes with mission critical operational features to grow your project. CMS, Commerce, Booking, Payin/Payout, Wallet, Escrow Account, Commission, Subscription, etc."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "max-w-3xl mx-auto text-center pb-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-xl text-green-400",
                                    "data-aos": "zoom-y-out",
                                    "data-aos-delay": "150",
                                    children: "All Plans comes with SuperAdmin, Editor, Headless API, Free Integrations & Pre-built Templates."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-wrap items-center justify-between mb-16 ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pricing_PricingModelToggle, {
                                        is_business_model: is_business_model,
                                        setISBusinessModel: setISBusinessModel
                                    }),
                                    !is_business_model && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pricing_AnnualToggle, {
                                        setIsYearly: setIsYearly,
                                        is_yearly: is_yearly
                                    })
                                ]
                            }),
                            is_business_model ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EnterPrisePricng, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Pricing_SMEPricing, {
                                userDetails: userDetails,
                                tenantDetails: tenantDetails,
                                is_annual: is_yearly
                            })
                        ]
                    })
                })
            }),
            !is_business_model && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pricing_SMBPricingBlocks, {})
        ]
    });
}
/* harmony default export */ var marketplace_PricingTablesMarketplace = (PricingTablesMarketplace);


/***/ }),

/***/ 55737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useGetPlansQuery; }
/* harmony export */ });
/* unused harmony export plansApi */
/* harmony import */ var _redux_api_TagTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26331);
/* harmony import */ var _redux_api_apiSlice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69356);


var plansApi = _redux_api_apiSlice__WEBPACK_IMPORTED_MODULE_1__/* .apiSlice.injectEndpoints */ .g.injectEndpoints({
    endpoints: function(builder) {
        return {
            //Get   Plans
            getPlans: builder.query({
                query: function() {
                    return "/v2/plans";
                },
                transformResponse: function(response, meta, arg) {
                    var ref;
                    var subscribed_plan = response === null || response === void 0 ? void 0 : (ref = response.plans) === null || ref === void 0 ? void 0 : ref.find(function(p) {
                        return p.subscribed;
                    });
                    var ref1, ref2, ref3;
                    return {
                        plans: (ref1 = response === null || response === void 0 ? void 0 : response.plans) !== null && ref1 !== void 0 ? ref1 : [],
                        old_plan: (ref2 = response === null || response === void 0 ? void 0 : response.old_plan) !== null && ref2 !== void 0 ? ref2 : [],
                        subscribed_plan: subscribed_plan !== null && subscribed_plan !== void 0 ? subscribed_plan : {},
                        subscribed_plan_name: (ref3 = subscribed_plan === null || subscribed_plan === void 0 ? void 0 : subscribed_plan.name) !== null && ref3 !== void 0 ? ref3 : ""
                    };
                },
                providesTags: [
                    _redux_api_TagTypes__WEBPACK_IMPORTED_MODULE_0__/* .tagTypes.plans */ .U.plans
                ]
            })
        };
    }
});
var useGetPlansQuery = plansApi.useGetPlansQuery;


/***/ }),

/***/ 59155:
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _asyncToGenerator = (__webpack_require__(60932)/* ["default"] */ .Z);
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
var getUserDetails = (__webpack_require__(10107)/* .getUserDetails */ .M_);
var ref = __webpack_require__(9669), axios = ref.default;
var ref1 = __webpack_require__(60538), getAuthKey = ref1.getAuthKey, getSelectedTenantDetails = ref1.getSelectedTenantDetails;
module.exports = {
    user_details: function() {
        var _ref = _asyncToGenerator(function(onSuccess, onError) {
            return _tsGenerator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getUserDetails(getAuthKey()).then(function(res) {
                                return onSuccess(res === null || res === void 0 ? void 0 : res.user);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(onSuccess, onError) {
            return _ref.apply(this, arguments);
        };
    }(),
    tenant_details: function() {
        var _ref = _asyncToGenerator(function(onSuccess, onError) {
            return _tsGenerator(this, function(_state) {
                axios.get("/api/user_tenants_details", {
                    params: {
                        auth_key: getAuthKey()
                    }
                }).then(function(res) {
                    onSuccess(getSelectedTenantDetails(res.data.data.tenants));
                });
                return [
                    2
                ];
            });
        });
        return function(onSuccess, onError) {
            return _ref.apply(this, arguments);
        };
    }()
};


/***/ }),

/***/ 33692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getFormattedPrice; }
/* harmony export */ });
/* harmony import */ var data_CurrencyData__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11262);

// in params currency code and amount will be passed
var getFormattedPrice = function(param) {
    var currency_code = param.currency_code, amount = param.amount;
    var currency = data_CurrencyData__WEBPACK_IMPORTED_MODULE_0__/* .currency_list.find */ .s.find(function(c) {
        return c.code === currency_code;
    });
    return currency.format.replace("{amount}", amount);
};


/***/ })

}]);